/** @jsx jsx */
import { jsx } from "theme-ui"

const GroupNewIcon = ({ style = {} }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
  >
    <g transform="translate(212.131 -462.041)">
      <g transform="translate(-212.131 462.041)">
        <g>
          <path
            d="M14.834,7.728,4.3-10.057s-.88-1.48-1.756,0L-20.345,28.568s-.876,1.48.843,1.48H4.867a12.3,12.3,0,1,1,9.967-22.32m12.348,20.84L20.93,18.015c0,.112.017.22.017.33a12.3,12.3,0,0,1-8.518,11.7H26.34s1.719,0,.842-1.48"
            transform="translate(20.569 10.715)"
            style={style}
          />
        </g>
        <g transform="translate(19.913 24.486)">
          <path
            d="M.506,0A9.3,9.3,0,0,0,16.49,9.492c-2.587.955-6.349.427-9.835-1.642S.907,2.73.506,0"
            transform="translate(0.701)"
            style={style}
          />
        </g>
      </g>
    </g>
  </svg>
)

export default GroupNewIcon
